import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { id: "app" } },
    [
      _c("ConfirmDialog", { ref: "confirm" }),
      _vm._v(" "),
      _c(
        VAppBar,
        { attrs: { app: "" } },
        [
          _c(
            VToolbarItems,
            { staticClass: "toolbar hidden-md-and-down" },
            [
              _vm._l(_vm.visibleHeaderItems, function (item, index) {
                return _c(
                  VBtn,
                  {
                    key: index,
                    attrs: {
                      depressed: "",
                      tile: "",
                      "x-small": "",
                      to: item.route,
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("\n          " + _vm._s(item.icon) + "\n        "),
                    ]),
                    _vm._v("\n        " + _vm._s(item.text) + "\n      "),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(VSpacer),
              _vm._v(" "),
              _vm.isLoggedIn
                ? _c(
                    VSheet,
                    {
                      staticClass: "userNameDisplay d-flex",
                      attrs: { tile: "" },
                    },
                    [
                      _c(VIcon, [_vm._v(" mdi-account ")]),
                      _vm._v(" " + _vm._s(_vm.userName) + "\n      "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoggedIn
                ? _c(
                    VBtn,
                    {
                      staticClass: "logoutButton mx-4",
                      attrs: {
                        tile: "",
                        depressed: "",
                        "x-small": "",
                        to: "/Logout",
                      },
                    },
                    [
                      _c(VIcon, [_vm._v(" mdi-logout ")]),
                      _vm._v("\n        Logout\n      "),
                    ],
                    1
                  )
                : _c(
                    VBtn,
                    {
                      staticClass: "logoutButton mx-4",
                      attrs: { tile: "", depressed: "", to: "/Login" },
                    },
                    [
                      _c(VIcon, [_vm._v(" mdi-login ")]),
                      _vm._v("\n        Login\n      "),
                    ],
                    1
                  ),
            ],
            2
          ),
          _vm._v(" "),
          _c(VAppBarNavIcon, {
            staticClass: "hidden-lg-and-up",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VNavigationDrawer,
        {
          attrs: { app: "" },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            VList,
            [
              _c(
                VListItemGroup,
                [
                  _vm._l(_vm.visibleHeaderItems, function (item) {
                    return _c(
                      VListItem,
                      { key: item.text, attrs: { to: item.route } },
                      [
                        _c(VIcon, [_vm._v(_vm._s(item.icon))]),
                        _vm._v(" "),
                        _c(VListItemTitle, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.text) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.isLoggedIn
                    ? _c(
                        VListItem,
                        { attrs: { to: "/Logout" } },
                        [
                          _c(VIcon, [_vm._v(" mdi-logout ")]),
                          _vm._v(" "),
                          _c(VListItemTitle, [
                            _vm._v(" Logout " + _vm._s(_vm.userName) + " "),
                          ]),
                        ],
                        1
                      )
                    : _c(
                        VListItem,
                        { attrs: { to: "/Login" } },
                        [
                          _c(VIcon, [_vm._v(" mdi-login ")]),
                          _vm._v(" "),
                          _c(VListItemTitle, [_vm._v(" Login ")]),
                        ],
                        1
                      ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(VMain, [_c("router-view")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }